import React from 'react'
import useMeta from '../hooks/useMeta';
import Meta from '../components/common/Meta';
import Faqs from './Faqs';
const FaqPage = () => {
    const meta = useMeta("faqs");
    return (
        <>
            {meta && (
                <Meta
                    title={meta.meta_title}
                    description={meta.meta_description}
                    keywords={meta.meta_keywords}
                />
            )}
           <Faqs />
        </>
    )
}

export default FaqPage